import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=dab7c336&scoped=true&"
import script from "./OrderConfirm.vue?vue&type=script&lang=js&"
export * from "./OrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderConfirm.vue?vue&type=style&index=1&id=dab7c336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab7c336",
  null
  
)

export default component.exports